import { createFileRoute } from "@tanstack/react-router";
import { CrudTable } from "@/features/admin/components/CrudTable";

export const Route = createFileRoute("/_authenticated/admin/courses")({
  component: () => (
    <CrudTable
      title="Courses"
      table="courses"
      orderBy={{ column: "sort_order", ascending: true }}
      columns={[
        { key: "name", label: "Name" },
        { key: "slug", label: "Slug" },
        { key: "age_min", label: "Age", render: (r) => `${r.age_min}-${r.age_max}` },
        { key: "price", label: "Price", render: (r) => `${r.price} EGP` },
        { key: "level", label: "Level" },
        { key: "is_published", label: "Published", render: (r) => (r.is_published ? "✅" : "❌") },
      ]}
      fields={[
        { key: "slug", label: "Slug (unique)", required: true },
        { key: "name", label: "Name", required: true },
        { key: "description", label: "Description", type: "textarea" },
        { key: "symbol", label: "Symbol/Emoji" },
        { key: "age_min", label: "Age Min", type: "number" },
        { key: "age_max", label: "Age Max", type: "number" },
        { key: "duration_weeks", label: "Duration (weeks)", type: "number" },
        { key: "level", label: "Level (beginner/intermediate/advanced)" },
        { key: "price", label: "Price (EGP)", type: "number" },
        { key: "image_url", label: "Image URL" },
        { key: "sort_order", label: "Sort Order", type: "number" },
        { key: "is_published", label: "Published", type: "switch", defaultValue: true },
      ]}
    />
  ),
});
